/**
 * Preview mode (contract §3.5): `?b2m_preview=<experimentId>:<groupId>`
 * applies one group's changes without assignment or exposure, for the tab's
 * lifetime. `?b2m_preview=off` clears it.
 */
import { getQueryParam, stripQueryParam } from './url-match';

export const PREVIEW_KEY = 'b2m_visual_preview';
export const PREVIEW_PARAM = 'b2m_preview';
const BADGE_ID = 'b2m-visual-preview-badge';

function readSession(win) {
  try {
    const v = win.sessionStorage.getItem(PREVIEW_KEY);
    const parsed = v ? JSON.parse(v) : null;
    return parsed && parsed.experimentId && parsed.groupId ? parsed : null;
  } catch (e) {
    return null;
  }
}

function writeSession(win, value) {
  try {
    if (value) win.sessionStorage.setItem(PREVIEW_KEY, JSON.stringify(value));
    else win.sessionStorage.removeItem(PREVIEW_KEY);
  } catch (e) {
    /* ignore */
  }
}

/** Parse "<experimentId>:<groupId>" (ids are GUIDs, so the first ':' splits). */
export function parsePreviewValue(value) {
  const s = String(value || '').trim();
  if (!s || s.toLowerCase() === 'off') return null;
  const i = s.indexOf(':');
  if (i <= 0 || i === s.length - 1) return null;
  return { experimentId: s.slice(0, i).trim().toLowerCase(), groupId: s.slice(i + 1).trim().toLowerCase() };
}

/** Resolve the preview state from the URL (and persist it) or from the session. */
export function resolvePreview(win) {
  const raw = getQueryParam(win.location.href, PREVIEW_PARAM);
  if (raw != null) {
    const parsed = parsePreviewValue(raw);
    stripQueryParam(win, PREVIEW_PARAM);
    writeSession(win, parsed);
    return parsed;
  }
  return readSession(win);
}

export function setPreview(win, experimentId, groupId) {
  const value = experimentId && groupId
    ? { experimentId: String(experimentId).toLowerCase(), groupId: String(groupId).toLowerCase() }
    : null;
  writeSession(win, value);
  return value;
}

export function showPreviewBadge(doc, label = 'B2M preview') {
  if (!doc || doc.getElementById(BADGE_ID)) return;
  const el = doc.createElement('div');
  el.id = BADGE_ID;
  el.textContent = label;
  el.setAttribute('style', [
    'position:fixed', 'left:12px', 'bottom:12px', 'z-index:2147483646', 'pointer-events:none',
    'font:600 11px/1 system-ui,-apple-system,Segoe UI,sans-serif', 'letter-spacing:.04em',
    'color:#fff', 'background:#0B7A5B', 'padding:6px 9px', 'border-radius:999px',
    'box-shadow:0 2px 8px rgba(0,0,0,.25)'
  ].join(';'));
  (doc.body || doc.documentElement).appendChild(el);
}

export function hidePreviewBadge(doc) {
  const el = doc && doc.getElementById(BADGE_ID);
  if (el && el.parentNode) el.parentNode.removeChild(el);
}
